import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import Head from "@/components/Head/index.vue";
import Pagination from "@/components/Pagination/index.vue";
import { defineComponent, reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { useStore } from "vuex";
export default defineComponent({
  name: "Reviewee",
  components: {
    Head: Head,
    Pagination: Pagination
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var router = useRouter();
    var store = useStore();
    var totalNumTwo = ref(10);
    var tab = ref([{
      participant: "",
      participantName: "",
      participantStatus: 0
    }]);
    var tableData = ref([{
      participant: "",
      participantName: "",
      participantStatus: 0
    }]);

    function hisoryDelete(val) {
      router.push({
        path: 'historyRecord',
        query: {
          listId: route.query.listId,
          userId: val.participant
        }
      });
    }

    function pge(num) {
      var as = num * 10;

      if (tab.value.length - 1 < num * 10) {
        as = tab.value.length;
      }

      for (var i = (num - 1) * 10; i < as; i++) {
        tableData.value[i] = tab.value[i];
      }
    }

    function changPageTwo(val) {
      tableData.value = [];
      pge(val);
    }

    function peoplelist(_x) {
      return _peoplelist.apply(this, arguments);
    }

    function _peoplelist() {
      _peoplelist = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["peoplelist"](id);

              case 2:
                res = _context.sent;

                if (res.code == 0) {
                  tab.value = res.data; //  tableData.value = 

                  pge(1);
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _peoplelist.apply(this, arguments);
    }

    var route = useRoute();
    peoplelist({
      listId: route.query.listId,
      userId: store.state.user.user.userId
    });
    var listtit = reactive({
      title: '',
      createTime: "",
      endTime: ""
    });

    function questionDemocracy(_x2) {
      return _questionDemocracy.apply(this, arguments);
    }

    function _questionDemocracy() {
      _questionDemocracy = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["questionDemocracy"](id);

              case 2:
                res = _context2.sent;

                if (res.code == 0) {
                  listtit.title = res.data.title;
                  listtit.createTime = res.data.createTime;
                  listtit.endTime = res.data.endTime; //  tableData.value = res.data
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _questionDemocracy.apply(this, arguments);
    }

    questionDemocracy(route.query.listId);
    return {
      tableData: tableData,
      hisoryDelete: hisoryDelete,
      listtit: listtit,
      changPageTwo: changPageTwo,
      totalNumTwo: totalNumTwo
    };
  }
});